import React from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuGroup,
  Text,
  Button,
} from "@chakra-ui/core";
import { Link } from "react-router-dom";

export const NavItem = (props) => {
  // const subLInks = props.links.filter((link) => {
  //   return link.dropdownLinks.length !== 0;
  // });

  return (
    <>
      {props.path !== null ? (
        <Link to={props.path}>
          <Text
            fontWeight='500'
            my={["4", "6", "6", "0"]}
            mx={["0", "4"]}
            fontFamily='Museo Sans'
            fontSize='16px'
          >
            {props.title}
          </Text>
        </Link>
      ) : (
        <Menu>
          {({ isOpen }) => {
            return (
              <>
                <MenuButton
                  as={Button}
                  bg='transparent'
                  rightIcon='chevron-down'
                  _focus='none'
                  onMouseOver={() => (isOpen = true)}
                  my={["4", "6", "6", "0"]}
                  mx={["0", "0"]}
                  fontWeight='500'
                  fontSize='16px'
                  _hover={{ bg: "#CDEDDC" }}
                >
                  {props.title}
                </MenuButton>

                <MenuList>
                  <MenuGroup title={props.title}>
                    {props.links.map((link, i) => {
                      return (
                        <MenuItem key={i} _focus={{ bg: "#CDEDDC" }}>
                          <Link to={link.path}>
                            <Text fontWeight='500'>{link.title}</Text>
                          </Link>
                        </MenuItem>
                      );
                    })}
                  </MenuGroup>
                </MenuList>
              </>
            );
          }}
        </Menu>
      )}
    </>
  );
};
